import { Badge } from '@axilon-apps/libs-ui-shadcn'
import { RbacRole, RbacRoleLabel } from '../../../constants'

type BadgeVariant = React.ComponentProps<typeof Badge>['variant']

interface Props {
  role: RbacRole
  /**
   * Retained for source compatibility with the original Joy chip API.
   * Currently a no-op — every UserRoleChip renders at Badge's default
   * size (`px-2 py-0.5 text-xs`) so it visually matches the surrounding
   * Badge primitives (`Not assigned`, MFA `Yes/No`, scope counts) that
   * live in the same tables. Before this change `size="sm"` shrunk the
   * chip to `text-[10px]`, making the Role column visibly smaller than
   * every neighbouring cell across the user-management tables.
   */
  size?: 'sm' | 'md' | 'lg'
}

const roleVariants: Record<RbacRole, BadgeVariant> = {
  [RbacRole.GlobalAdmin]: 'default',
  [RbacRole.MachineAdmin]: 'success',
  [RbacRole.Developer]: 'warning',
  [RbacRole.Admin]: 'default',
  [RbacRole.Engineer]: 'secondary',
  [RbacRole.Operator]: 'info',
  [RbacRole.Viewer]: 'neutral',
  [RbacRole.ServiceAccount]: 'outline',
  [RbacRole.Maintenance]: 'outline',
  [RbacRole.IngestUploader]: 'outline',
  [RbacRole.DevopsSync]: 'outline'
}

const UserRoleChip = ({ role }: Props) => (
  <Badge variant={roleVariants[role]}>{RbacRoleLabel[role]}</Badge>
)

export default UserRoleChip
